import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';
import { ProjectActions } from '../../../actions/project';

import ProjectContainer from './ProjectContainer';

import {
  currentProjectSelector,
  currentProjectIdSelector,
} from '../../../reducers/projects';
import {
  currentUserSelector,
  userModeSelector,
  usersSelector,
  getUserModeByProjectId,
} from '../../../reducers/users';
import {
  filterProjectUsers,
  projectsUsersSelector,
} from '../../../reducers/projectsUsers';
import '../../../styles/ProjectDefaultTab.css';

const DefaultPageSelector = immutableCreatorSelector(
  [
    currentProjectSelector,
    currentUserSelector,
    userModeSelector,
    currentProjectIdSelector,
    usersSelector,
    projectsUsersSelector,
  ],
  (project, user, userMode, currentProjectId, users, projectsUsers, product) => {
    return {
      project,
      currentProjectId,
      user,
      users,
      userMode: getUserModeByProjectId(user, currentProjectId),
      projectUsers: filterProjectUsers(projectsUsers, users, currentProjectId),
    };
  },
);

@connect(DefaultPageSelector)
export default class ProjectWrapper extends Component {
  static propTypes = {
    user: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
    project: PropTypes.instanceOf(Map),
    currentProjectId: PropTypes.string,
    userMode: PropTypes.string,
  };

  componentDidMount() {
    const { dispatch, currentProjectId } = this.props;

    dispatch(ProjectActions.setCurrentProjectId(currentProjectId));
  }

  render() {
    const { project, user, route } = this.props;

    if (!project || !user || !user.size) return <div />;

    const product = (route && route.product) || 'planner';

    return <ProjectContainer product={product} {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/views/Project/TaskHome/ProjectWrapper.js